import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Activity } from "services";
import { ModelsActions } from "store/actions";
import { curriculum_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import { Summary, Media } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const ActivityDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { activity_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.activity);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Activity.detail(activity_id);
      dispatch(ModelsActions.update_model({ activity: model }));
    }).finally(() => setLoading(false));

    // eslint-disable-next-line
  }, [activity_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
    { value: "media", label: "Media" },

  ];

  if (!tab) {
    return <Redirect to={`/activities/${activity_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Activity.del(activity_id);
      router.history.push('/activities');
    }).finally(() => mounted && setLoading(false));
  }

  return (
    <AuthGuard roles={[curriculum_manager]} projects={[]}>
      <Page className={classes.root} title="Activity Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.title} header="Activity" subtitle={model.reference} />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary handleDelete={handleDelete} />}
            {tab === "media" && <Media />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

ActivityDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default ActivityDetail;
